import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BASE}/api`;

export const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("examnest_token");
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

export const authApi = {
  signup: (data) => api.post("/auth/signup", data).then((r) => r.data),
  login: (data) => api.post("/auth/login", data).then((r) => r.data),
  me: () => api.get("/auth/me").then((r) => r.data),
};

export const questionsApi = {
  list: (params) => api.get("/questions", { params }).then((r) => r.data),
  create: (data) => api.post("/questions", data).then((r) => r.data),
  update: (id, data) => api.put(`/questions/${id}`, data).then((r) => r.data),
  remove: (id) => api.delete(`/questions/${id}`).then((r) => r.data),
};

export const importApi = {
  parse: (formData) => api.post("/import/parse", formData, {
    headers: { "Content-Type": "multipart/form-data" }
  }).then((r) => r.data),
  commit: (questions) => api.post("/import/commit", { questions }).then((r) => r.data),
  predictDifficulty: (texts) => api.post("/import/ai-difficulty", { texts }).then((r) => r.data),
};

export const testsApi = {
  list: () => api.get("/tests").then((r) => r.data),
  get: (id, includeQuestions = false) =>
    api.get(`/tests/${id}`, { params: { include_questions: includeQuestions } }).then((r) => r.data),
  create: (data) => api.post("/tests", data).then((r) => r.data),
  remove: (id) => api.delete(`/tests/${id}`).then((r) => r.data),
  random: (data) => api.post("/tests/random", data).then((r) => r.data),
  assign: (data) => api.post("/tests/assign", data).then((r) => r.data),
  parentAssign: (data) => api.post("/tests/parent-assign", data).then((r) => r.data),
};

export const attemptsApi = {
  start: (test_id) => api.post("/attempts/start", { test_id }).then((r) => r.data),
  submit: (data) => api.post("/attempts/submit", data).then((r) => r.data),
  list: (params) => api.get("/attempts", { params }).then((r) => r.data),
  get: (id) => api.get(`/attempts/${id}`).then((r) => r.data),
};

export const analyticsApi = {
  admin: () => api.get("/analytics/admin").then((r) => r.data),
  student: (sid) => api.get(`/analytics/student/${sid}`).then((r) => r.data),
  parent: (cid) => api.get(`/analytics/parent/${cid}`).then((r) => r.data),
  leaderboard: (kind = "coins") => api.get("/leaderboard", { params: { kind } }).then((r) => r.data),
};

export const usersApi = {
  list: (role) => api.get("/users", { params: role ? { role } : {} }).then((r) => r.data),
  get: (id) => api.get(`/users/${id}`).then((r) => r.data),
};

export const rewardsApi = {
  me: () => api.get("/rewards/me").then((r) => r.data),
  useFreeze: () => api.post("/rewards/freeze/use").then((r) => r.data),
};

export const percentileApi = {
  get: (testId, score) => api.get(`/analytics/test-percentile/${testId}`, { params: { score } }).then((r) => r.data),
};

export const duelsApi = {
  create: (data) => api.post("/duels", data).then((r) => r.data),
  get: (code) => api.get(`/duels/${code}`).then((r) => r.data),
  complete: (code, attempt_id) => api.post(`/duels/${code}/complete`, { attempt_id }).then((r) => r.data),
};

export const wrongRetestApi = {
  create: (attemptId) => api.post(`/attempts/${attemptId}/wrong-retest`).then((r) => r.data),
};

export const podcastsApi = {
  chapters: () => api.get("/podcasts/chapters").then((r) => r.data),
  script: (subject, chapter) => api.post("/podcasts/script", { subject, chapter }).then((r) => r.data),
};

export const digestApi = {
  weekly: (childId) => api.get(`/parent/digest/${childId}`).then((r) => r.data),
};

export const notificationsApi = {
  list: () => api.get("/notifications").then((r) => r.data),
  read: (id) => api.post(`/notifications/read/${id}`).then((r) => r.data),
};

export const announcementsApi = {
  list: () => api.get("/announcements").then((r) => r.data),
  create: (data) => api.post("/announcements", data).then((r) => r.data),
};

export const metaApi = {
  subjects: () => api.get("/meta/subjects").then((r) => r.data),
};
